import { createReducer, on } from '@ngrx/store';
import * as CountryListActions from './Countrylist.action';

export interface CountryListState {
  countries: any[];
  loading: boolean;
  error: any;
}

export const initialCountryListState: CountryListState = {
  countries: [],
  loading: false,
  error: null,
};

export const countryListReducer = createReducer(
  initialCountryListState,
  on(CountryListActions.loadCountryList, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CountryListActions.loadCountryListSuccess, (state, { countries }) => ({
    ...state,
    countries,
    loading: false,
    error: null,
  })),
  on(CountryListActions.loadCountryListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
